import { incrementTelemetry } from 'core-events/actions';
import noop from 'lodash/noop';
import React, { JSX, useState } from 'react';

import Dropdown from '../../../../components/components/elements/Dropdown';
import { ContentTypes, ContentTypesWithSnapshots } from './ContentTypes';

import './navSearchDropdown.css';

export default function NavSearchDropdown({
    onChange = noop,
    value = '',
    useSnapshots = false,
}: {
    onChange: (value: string) => void;
    value: string;
    useSnapshots?: boolean;
}): JSX.Element {
    const [isOpen, setIsOpen] = useState(false);
    const options = useSnapshots ? ContentTypesWithSnapshots : ContentTypes;

    const dropdownToggle = () => {
        setIsOpen((prev) => !prev);
    };

    const dropdownClose = () => {
        setIsOpen(false);
    };

    const dropdownSelect = (value: string) => {
        onChange(value);
        void incrementTelemetry(`nav.search.${value}`);
        dropdownClose();
    };

    return (
        <Dropdown
            options={options}
            value={value}
            isOpen={isOpen}
            onToggle={dropdownToggle}
            onClose={dropdownClose}
            onSelect={dropdownSelect}
        />
    );
}
